/* eslint-disable no-bitwise */
import * as React from "react";
import * as Survey from "survey-react";

import { createSurveyConfig } from "../../../service/forms/marae-booking/survey-config";
import { transformMaraeBookingData } from "../../../utility/form-transforms/transform-marae-booking-data";
import { CustomerFormQuestionTypes } from "./customer-form-types";
import { BenefitForm } from "./benefit-form";

export const MaraeForm = () => {
    const transformData = (survey: Survey.ReactSurveyModel) =>
        transformMaraeBookingData(survey);

    return (
        <BenefitForm
            createSurveyConfig={createSurveyConfig}
            transformData={transformData}
            questionTypes={
                CustomerFormQuestionTypes.AddressFinder |
                CustomerFormQuestionTypes.DatePicker
            }
            publicForm
        />
    );
};
